var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/logo/logo-black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c(
            "main",
            {
              staticClass: "st-MainContents",
              staticStyle: { "padding-top": "120px" }
            },
            [
              _c("nav", { staticClass: "series-Nav sw-stickyTrigger-target" }, [
                _c(
                  "div",
                  { staticClass: "series-Nav_Inner series-Nav_Inner_company" },
                  [
                    _c("ul", { staticClass: "mb-0" }, [
                      _c(
                        "li",
                        { staticClass: "current" },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/solution/logistics-automation" } },
                            [
                              _c("img", {
                                staticStyle: { "object-fit": "cover" },
                                attrs: {
                                  height: "50",
                                  width: "50",
                                  src: require("../../../../static/img/home/menu-logistics-automation.jpg"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("h4", { staticClass: "pl-md-4" }, [
                                _vm._v(
                                  "ロボティクス自動化ソリューション\n                  "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/solution/low-code" } },
                            [
                              _c("img", {
                                staticStyle: { "object-fit": "cover" },
                                attrs: {
                                  height: "50",
                                  width: "50",
                                  src: require("../../../../static/img/home/menu-low-code.jpg"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c("h4", { staticClass: "pl-3 pl-md-4" }, [
                                _vm._v(
                                  "Lowコードソリューション\n                  "
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _c("section", { staticClass: "company-Profile" }, [
                _c("div", { staticClass: "company-Profile_Inner" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "st-Grid_Inner p-0 solution-logistics-automation-appear-1",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c(
                        "h2",
                        {
                          staticClass:
                            "common-text-appear text-center solution-logistics-automation-appear-2",
                          attrs: { "data-appear": "true" }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "sw-Section_Header-en pb-3" },
                            [
                              _c(
                                "b",
                                [
                                  _c(
                                    "font",
                                    [
                                      _c("font", [
                                        _vm._v(
                                          "ロボティクス自動化ソリューション"
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(1)
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "st-Breadcrumbs" }, [
            _c("ul", { staticClass: "st-BreadcrumbsList" }, [
              _c(
                "li",
                { staticClass: "st-BreadcrumbsList_Item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "st-BreadcrumbsList_Item-link",
                      attrs: { to: "/" }
                    },
                    [
                      _c(
                        "p",
                        { attrs: { itemprop: "item", "aria-current": "page" } },
                        [
                          _c("span", { attrs: { itemprop: "name" } }, [
                            _vm._v("ホーム")
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(2)
            ])
          ])
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "series-PageTitle" }, [
      _c(
        "div",
        { staticClass: "series-PageTitle_Inner", attrs: { "data-appear": "" } },
        [
          _c("h1", [
            _c("span", { staticClass: "series-PageTitle_Logo" }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "series-PageTitle_Title",
                staticStyle: { color: "#FFF" }
              },
              [_vm._v("ロボティクス自動化ソリューション")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sw-parallax" }, [
            _c("div", { staticClass: "sw-parallax_outer js-parallax_outer" }, [
              _c("div", { staticClass: "sw-parallax_inner" }, [
                _c(
                  "div",
                  { staticClass: "sw-parallax_block js-parallax_block" },
                  [
                    _c("div", {
                      staticClass:
                        "sw-parallax_target promotion-PageTitle-visual",
                      staticStyle: {
                        background:
                          "url(../../../../static/img/solution/logistics-automation/top.jpg) 50%/cover no-repeat",
                        top: "70px",
                        height: "480px"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fast-detail-body" }, [
      _c("div", { staticClass: "col-12 px-0" }, [
        _c(
          "div",
          { staticClass: "content-wrapper-home-fast st-grid-padding" },
          [
            _c(
              "div",
              {
                staticClass:
                  "common-image-appear solution-logistics-automation-appear-3",
                attrs: { "data-appear": "true" }
              },
              [
                _c("picture", { staticClass: "text-center pt-5" }, [
                  _c("div", { staticClass: "show-pc" }, [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: require("../../../../static/img/solution/logistics-automation/05.jpg")
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "show-sp" }, [
                    _c("img", {
                      attrs: {
                        width: "100%",
                        src: require("../../../../static/img/solution/logistics-automation/05.jpg")
                      }
                    })
                  ])
                ])
              ]
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "st-BreadcrumbsList_Item" }, [
      _c("p", { attrs: { itemprop: "item", "aria-current": "page" } }, [
        _c("span", { attrs: { itemprop: "name" } }, [
          _vm._v("ロボティクス自動化ソリューション")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3450088", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3450088","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/solution/logistics-automation.vue
// module id = null
// module chunks = 